import { useState } from 'react';
import { Input, Tooltip, Alert } from 'antd';
import { PlusOutlined, DeleteOutlined } from '@ant-design/icons';
import { statusEntriesToStatusMap, statusMapToEntries } from 'src/_shared/services/claus/serde';

// Status mappings (candidate integrations only): source status → target status/stage. The row editor
// covers the common "standard" mapping and (loaded) advanced/conditional entries pass through
// untouched; JSON mode gives full expressiveness (sourceStageValue, conditions) for parity.
export default function StatusMappingsSection({ entries, onChange }) {
	const [mode, setMode] = useState('fields');
	const [json, setJson] = useState('');
	const [jsonError, setJsonError] = useState('');

	const list = entries || [];
	const setRow = (i, field, value) => onChange(list.map((r, idx) => (idx === i ? { ...r, [field]: value } : r)));
	const addRow = () => onChange([...list, { sourceValue: '', targetStatus: '', targetStage: '' }]);
	const removeRow = (i) => onChange(list.filter((_, idx) => idx !== i));

	const toJson = () => {
		setJson(JSON.stringify(statusEntriesToStatusMap(list), null, 2));
		setJsonError('');
		setMode('json');
	};
	const toFields = () => {
		try {
			const parsed = JSON.parse(json || '{"statusMap":[]}');
			if (!parsed || !Array.isArray(parsed.statusMap)) {
				setJsonError('Must be a JSON object with a "statusMap" array.');
				return;
			}
			onChange(statusMapToEntries(parsed));
			setJsonError('');
			setMode('fields');
		} catch {
			setJsonError('Invalid JSON.');
		}
	};

	return (
		<>
			<div className="js-card-head" style={{ marginBottom: 8 }}>
				<span className="js-muted">Map incoming status values to Erin statuses and stages.</span>
				<div className="js-modetoggle">
					<button
						type="button"
						className={`js-modeopt${mode === 'fields' ? ' is-selected' : ''}`}
						onClick={mode === 'json' ? toFields : undefined}
					>
						Fields
					</button>
					<button
						type="button"
						className={`js-modeopt${mode === 'json' ? ' is-selected' : ''}`}
						onClick={mode === 'fields' ? toJson : undefined}
					>
						JSON
					</button>
				</div>
			</div>

			{mode === 'fields' ? (
				<>
					{list.map((row, i) => (
						// eslint-disable-next-line react/no-array-index-key
						<div className="ei-kv-row" key={i}>
							<div className="js-token" style={{ flex: 1 }}>
								<Input
									value={row.sourceValue}
									placeholder="source value (e.g. Offer)"
									onChange={(e) => setRow(i, 'sourceValue', e.target.value)}
								/>
							</div>
							<span className="js-arrow">→</span>
							<div className="js-token" style={{ flex: 1 }}>
								<Input
									value={row.targetStatus}
									placeholder="target status"
									onChange={(e) => setRow(i, 'targetStatus', e.target.value)}
								/>
							</div>
							<div className="js-token" style={{ flex: 1 }}>
								<Input
									value={row.targetStage}
									placeholder="target stage (optional)"
									onChange={(e) => setRow(i, 'targetStage', e.target.value)}
								/>
							</div>
							<Tooltip title="Remove">
								<button type="button" className="js-iconbtn js-danger" onClick={() => removeRow(i)} aria-label="Remove">
									<DeleteOutlined />
								</button>
							</Tooltip>
						</div>
					))}
					<div style={{ marginTop: 10 }}>
						<button type="button" className="js-linkbtn" onClick={addRow}>
							<PlusOutlined /> Add status mapping
						</button>
					</div>
					<div className="js-muted" style={{ marginTop: 8 }}>
						For stage-specific or conditional mappings, use JSON mode.
					</div>
				</>
			) : (
				<>
					<Input.TextArea
						className="js-mono"
						rows={12}
						value={json}
						onChange={(e) => {
							setJson(e.target.value);
							setJsonError('');
						}}
						placeholder='{ "statusMap": [ { "sourceValue": "Offer", "targetStatus": "hired", "targetStage": "Onboarding" } ] }'
					/>
					{jsonError && <Alert style={{ marginTop: 8 }} type="error" showIcon message={jsonError} />}
				</>
			)}
		</>
	);
}
